var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabbar" }, [
    _c("div", { staticClass: "page-position", attrs: { id: "jzqTabbar" } }),
    _c(
      "div",
      {
        staticClass: "tabbar-item",
        class: { active: Number(_vm.current) === 1 }
      },
      [
        _c(
          "router-link",
          { staticClass: "text", attrs: { to: "/judicialService/safeguard" } },
          [_vm._v("办理进度")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aaedb818", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaedb818","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/judicialService/tabbar.vue
// module id = HXF7
// module chunks = 67 68 69 70 71 78 79 80 81 180